import { motion, useScroll, useTransform } from "framer-motion";
import { Users, Target, Briefcase } from "lucide-react";

export default function AboutSection() {
  const { scrollY } = useScroll();
  const parallaxY = useTransform(scrollY, [0, 500], [0, 120]); // subtle parallax

  return (
    <section id="about" className="relative px-6 py-24 max-w-6xl mx-auto">
      {/* Parallax Background Shape */}
      <motion.div
        style={{ y: parallaxY }}
        className="absolute top-10 left-1/2 -translate-x-1/2 w-[700px] h-[700px] 
                   bg-orange-100 opacity-40 rounded-full blur-3xl pointer-events-none"
      />

      <div className="text-center relative z-10">
        <h2 className="text-4xl font-bold mb-6">About Us</h2>
        <p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto mb-16">
          Talent Squeed is one of India's leading HR Consulting firms offering
          Recruitment, HR Outsourcing, Training, Assessments and Business
          Advisory solutions powered by globally experienced professionals.
        </p>
      </div>

      {/* Cards Section */}
      <div className="grid md:grid-cols-3 gap-10 relative z-10">
        {/* Card 1 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="bg-white/80 backdrop-blur-xl p-8 rounded-2xl shadow-xl text-center"
        >
          <div className="flex justify-center mb-4">
            <Users size={50} className="text-orange-500" />
          </div>
          <h3 className="text-xl font-semibold mb-4">Who We Are</h3>
          <p className="text-gray-600 text-base leading-relaxed">
            A trusted partner for organizations across India, delivering
            quality-driven recruitment and HR solutions.
          </p>
        </motion.div>

        {/* Card 2 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="bg-white/80 backdrop-blur-xl p-8 rounded-2xl shadow-xl text-center"
        >
          <div className="flex justify-center mb-4">
            <Target size={50} className="text-orange-500" />
          </div>
          <h3 className="text-xl font-semibold mb-4">Our Vision</h3>
          <p className="text-gray-600 text-base leading-relaxed">
            To set new benchmarks in HR excellence while enabling businesses to
            scale with efficiency, confidence, and agility.
          </p>
        </motion.div>

        {/* Card 3 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="bg-white/80 backdrop-blur-xl p-8 rounded-2xl shadow-xl text-center"
        >
          <div className="flex justify-center mb-4">
            <Briefcase size={50} className="text-orange-500" />
          </div>
          <h3 className="text-xl font-semibold mb-4">Our Expertise</h3>
          <p className="text-gray-600 text-base leading-relaxed">
            Recruitment, HR Outsourcing, PMS, Training, Legal Support,
            Assessments, Customer Care solutions & more.
          </p>
        </motion.div>
      </div>

      {/* Bullet Points Section */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.7 }}
        viewport={{ once: true }}
        className="max-w-4xl mx-auto mt-20 relative z-10"
      >
        <h3 className="text-2xl font-bold text-center mb-8">
          How We Help Businesses
        </h3>

        <ul className="space-y-4 text-lg text-gray-700">
          <li className="flex items-start">
            <span className="text-orange-500 text-2xl mr-3">•</span>
            Enter new markets with confidence
          </li>
          <li className="flex items-start">
            <span className="text-orange-500 text-2xl mr-3">•</span>
            Increase profits in existing markets
          </li>
          <li className="flex items-start">
            <span className="text-orange-500 text-2xl mr-3">•</span>
            Achieve operational efficiency
          </li>
          <li className="flex items-start">
            <span className="text-orange-500 text-2xl mr-3">•</span>
            Stay ahead of the competition
          </li>
          <li className="flex items-start">
            <span className="text-orange-500 text-2xl mr-3">•</span>
            Deliver world-class quality at optimal cost
          </li>
        </ul>
      </motion.div>
    </section>
  );
}
